export function groupByExperiments(fileCollection) {
    const experiments = {};
    const fileList = fileCollection.files.map((file) => file.relativePath);
    for (const file of fileCollection) {
        const filename = file.name.toLowerCase();
        if (filename.match(/^(fid|procpar|text|log)$/)) {
            if (filename.match(/^(fid|text|log)$/)) {
                const neededFile = file.relativePath.replace(/(fid|text|log)$/, 'procpar');
                if (!fileList.includes(neededFile))
                    continue;
            }
            const parts = file.relativePath.split('/');
            const id = parts.slice(0, -1).join('/');
            if (!experiments[id]) {
                experiments[id] = {
                    name: parts.slice(-2, -1)[0],
                    files: [],
                };
            }
            experiments[id].files.push(file);
        }
    }
    return experiments;
}
//# sourceMappingURL=groupByExperiments.js.map